// extracted by mini-css-extract-plugin
module.exports = {"discount":"style_discount__YwDeD","error":"style_error__EyCyQ","active":"style_active__S06OX"};